<template>
    <div>
    <!--Edit-->
    <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">{{ Mensagem.mpdId ? 'Alterar mensagem padrão' : 'Nova mensagem padrão' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Cadastro de mensagens padrão</a> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><span>{{ Mensagem.mpdId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="gp-admin-form-header"><span><v-icon size="20">mdi-message-text-outline</v-icon></span><div><h4>{{ Mensagem.mpdId ? 'Alterar mensagem padrão' : 'Nova mensagem padrão' }}</h4><p>Configure o conteúdo e a disponibilidade desta mensagem.</p></div></div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="Mensagem.mpdId" type="text" class="form-control"
                                                placeholder="Id" />
                                        </div>
                                    </div>
                                    <div class="col-md-8 col-lg-8">
                                        <div class="form-group">
                                            <label>Título</label>
                                            <input v-model="Mensagem.mpdNome"
                                                type="text" class="form-control" placeholder="Nome" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <div class="form-group">
                                            <label>Ativo</label>
                                            <select v-model="Mensagem.mpdAtivo" class="form-select form-control"
                                                id="defaultSelect">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div v-if="Mensagem.mpdIdReferencia > 0" class="col-md-2 col-lg-2">
                                        <div class="form-group">
                                            <label>Personalização</label>
                                            <input :value="nomeGarantidora(Mensagem.garId)" type="text" class="form-control" disabled />
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label>Texto</label>
                                            <ckeditor :editor="editor" @ready="onReady" v-model="Mensagem.mpdTexto" :config="$ckconfig"></ckeditor>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label for="exampleFormControlFile1">Upload da Imagem</label>
                                            <v-file-input v-model="selectedFile" label="Imagem" variant="underlined"
                                                prepend-icon="mdi-account-circle" accept="image/*"></v-file-input>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2" v-if="Mensagem.mpdUrlImagem !== '' && Mensagem.mpdUrlImagem !== null">
                                        <div class="form-group">
                                            <img :src="$imgURL + Mensagem.mpdUrlImagem" style="width: 100px" />
                                            <v-btn icon density="compact" color="red" class="delete-icon"
                                                variant="text">
                                                <v-icon @click="DeleteImagem()"
                                                    style="font-size:22px;">mdi-alpha-x-circle</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-admin-actions gp-detail-actions">
                        <button v-if="Mensagem.mpdId != 0" type="button" class="btn btn-success"
                            style="color:#ffffff;" @click="Put()">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()"  class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de mensagens padrão</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body">
                                 <adm-data-table :headers="headers" :items="Mensagens" v-model="itemsSelected" alternating
                                    :filter-options="{ garId: [{ title: 'Padrão', value: null }, ...Garantidoras.map(item => ({ title: item.garNomeEmpresa, value: item.garId }))] }"
                                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina" file-name="mensagens-padrao">
                                    <template #item-mpdAtivo="item">
                                        <span>{{ item.mpdAtivo ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-garId="item">
                                        <span>{{ item.mpdIdReferencia > 0 ? nomeGarantidora(item.garId) : 'Padrão' }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <div class="gp-table-actions">
                                            <button type="button" class="gp-table-action gp-action-edit" title="Editar" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
                                            <button v-if="item.mpdIdReferencia === 0" type="button" class="gp-table-action gp-action-copy" title="Personalizar por garantidora" @click="AbrirPersonalizacao(item)"><v-icon size="17">mdi-content-copy</v-icon></button>
                                            <button type="button" class="gp-table-action gp-action-delete" title="Excluir" @click="DeleteGrid(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
                                        </div>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-dialog v-model="dialogPersonalizacao" persistent max-width="480">
            <v-card class="gp-replicate-dialog">
                <v-card-title class="gp-replicate-dialog__header">
                    <span class="gp-replicate-dialog__icon"><v-icon size="21">mdi-message-text-outline</v-icon></span>
                    <span><strong>Personalizar mensagem</strong><small>Crie uma versão específica para uma garantidora.</small></span>
                </v-card-title>
                <v-card-text class="gp-replicate-dialog__body">
                    <div class="form-group mb-0">
                        <label>Mensagem padrão</label>
                        <input :value="MensagemBase?.mpdNome" class="form-control mb-3" disabled />
                        <label>Garantidora <span class="text-danger">*</span></label>
                        <v-autocomplete v-model="SelectedGarId" :items="GarantidorasGeral"
                            item-title="garNomeEmpresa" item-value="garId" density="compact" variant="outlined"
                            placeholder="Digite para pesquisar" clearable hide-details
                            no-data-text="Nenhuma garantidora encontrada" />
                        <small class="gp-replicate-dialog__hint"><v-icon size="14">mdi-information-outline</v-icon> A mensagem padrão será mantida sem alterações.</small>
                    </div>
                </v-card-text>
                <v-card-actions class="gp-replicate-dialog__actions">
                    <button type="button" class="btn btn-outline-secondary" @click="dialogPersonalizacao = false">Cancelar</button>
                    <button type="button" class="btn btn-success" @click="CriarPersonalizacao"><v-icon size="16">mdi-content-copy</v-icon> Criar personalização</button>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
//import { isExtensible } from 'core-js/core/object';

export default {
    name: 'CadastroMensagensPadraoView',
    components: {
        EasyDataTable,
        //isExtensible
    },
    data: () => ({
        EditView: false,
        editor: DecoupledEditor,
        Mensagem: {
            mpdId: 0,
            mpdNome: '',
            mpdTexto: '',
            mpdAtivo: '',
            mpdUrlImagem: '',
            garId: null,
            mpdIdReferencia: 0
        },
        Mensagens: [],
        StatusAtivo: [{ nome: "Sim", mpdAtivo: true }, { nome: "Não", mpdAtivo: false }],
        headers: [
            { text: "Id", value: "mpdId", sortable: true, },
            { text: "Nome", value: "mpdNome", sortable: true, },
            { text: "Ativo", value: "mpdAtivo", sortable: true, },
            { text: "Aplicação", value: "garId", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
        selectedFile: null,
        Garantidoras:[],
        GarantidorasGeral:[],
        dialogPersonalizacao: false,
        SelectedGarId: null,
        MensagemBase: null,
    }),
    methods: {
       onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
          //edit
        EditNew(){
            this.EditView = true;
            this.Mensagem.mpdId = 0;
            this.Mensagem.mpdNome = '';
            this.Mensagem.mpdTexto = '';
            this.Mensagem.mpdAtivo = '';
            this.Mensagem.mpdUrlImagem = '';
            this.Mensagem.garId = '';
            this.Mensagem.mpdIdReferencia = 0;
            this.selectedFile = null;
            
        },
        EditGrid(item) {
            this.EditView = true;
            if (item.mpdId != ''){
            axios.get(`/Telas/MensagensPadrao/GetById/` + item.mpdId)
                .then(response => {
                    this.Mensagem = response.data;
                })
                .catch(error => {
                    if (!error.__gpNotified) {
                        this.$mensagemErro(this.$obterMensagemErro(error));
                    }
                });
            }
            else{
                this.GarantidoraSelected();
            }
        },
        AbrirPersonalizacao(item) {
            this.MensagemBase = item;
            this.SelectedGarId = null;
            this.dialogPersonalizacao = true;
        },
        async CriarPersonalizacao() {
            if (!this.SelectedGarId) {
                this.$mensagemAviso('Selecione a garantidora.');
                return;
            }
            const duplicada = this.Mensagens.some(x =>
                x.mpdIdReferencia === this.MensagemBase.mpdId && x.garId === this.SelectedGarId
            );
            if (duplicada) {
                this.$mensagemAviso('Esta garantidora já possui uma personalização para essa mensagem.');
                return;
            }
            try {
                const base = (await axios.get(`/Telas/MensagensPadrao/GetById/${this.MensagemBase.mpdId}`)).data;
                const nova = {
                    ...base,
                    mpdId: 0,
                    garId: this.SelectedGarId,
                    mpdIdReferencia: this.MensagemBase.mpdId
                };
                const response = await axios.post('/Telas/MensagensPadrao/Add', nova);
                this.dialogPersonalizacao = false;
                await this.Get();
                this.$mensagemAvisoSucesso('Personalização criada.');
                const criada = this.Mensagens.find(x => x.mpdId === response.data);
                if (criada) this.EditGrid(criada);
            } catch (error) {
                if (!error.__gpNotified) this.$mensagemErro(this.$obterMensagemErro(error));
            }
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Telas/MensagensPadrao/upload`, formData);
            return uploadResult;
        },
        async Add() {
            if (this.Mensagem.mpdNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.Mensagem.mpdTexto == ''){
                this.$mensagemAviso("Texto Obrigatório.")
            }
            else {
                if (this.Mensagem.garId === "" || this.Mensagem.garId === null) {
                    this.Mensagem.garId = null;
                }
                if (this.selectedFile != '' && this.selectedFile != null) {
                    //console.log(this.selectedFile[0].size)
                    const uploadSuccess = await this.UploadImg(this.selectedFile[0]);
                    if (uploadSuccess.status == 200) {
                        this.Mensagem.mpdUrlImagem = uploadSuccess.data.nameFile;
                        if (this.Mensagem.mpdAtivo === "" || this.Mensagem.mpdAtivo === null){
                            this.Mensagem.mpdAtivo = true;
                        }
                        axios.post(`/Telas/MensagensPadrao/Add`, this.Mensagem)
                        .then(response => {
                            if (response.data > 0) {
                                this.$mensagemAvisoSucesso("Registro Incluído.")
                                this.Get();
                            }
                        });
                    }
                    else {
                        this.$mensagemErro("Não foi possível carregar imagem.")
                    }
                }
                else {
                    this.Mensagem.mpdUrlImagem = "";
                        if (this.Mensagem.mpdAtivo === "" || this.Mensagem.mpdAtivo === null){
                            this.Mensagem.mpdAtivo = true;
                        }
                        axios.post(`/Telas/MensagensPadrao/Add`, this.Mensagem)
                        .then(response => {
                            if (response.data > 0) {
                                this.$mensagemAvisoSucesso("Registro Incluído.")
                                this.Get();
                            }
                        });
                }
            }
        },
        async Put() {
            if (this.Mensagem.mpdNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.Mensagem.mpdTexto == ''){
                this.$mensagemAviso("Texto Obrigatório.")
            }
            else {
                if (this.selectedFile != '' && this.selectedFile != null) {
                    //console.log(this.selectedFile[0].size)
                    const uploadSuccess = await this.UploadImg(this.selectedFile[0]);
                    if (uploadSuccess.status == 200) {
                        this.Mensagem.mpdUrlImagem = uploadSuccess.data.nameFile;
                        if (this.Mensagem.mpdAtivo === "" || this.Mensagem.mpdAtivo === null){
                            this.Mensagem.mpdAtivo = true;
                        }
                        axios.put(`/Telas/MensagensPadrao/Update`, this.Mensagem)
                        .then(response => {
                            if (response.status == 200) {
                                this.$mensagemAvisoSucesso("Registro Alterado.")
                                this.Get();
                            }
                        });
                    }
                    else {
                        this.$mensagemErro("Não foi possível carregar imagem.")
                    }
                }
                else{
                    if (this.Mensagem.mpdUrlImagem != "") {
                        this.Mensagem.mpdUrlImagem = "0";
                    }
                    if (this.Mensagem.mpdAtivo === "" || this.Mensagem.mpdAtivo === null){
                            this.Mensagem.mpdAtivo = true;
                    }
                    axios.put(`/Telas/MensagensPadrao/Update`, this.Mensagem)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                        }
                    });
                }              
            }
        },
        EditCancel(){
            //window.location.reload();
            this.$router.go(0);
        },
        GarantidoraSelected(){
            this.Mensagem.garId = null;
            this.Garantidoras = this.GarantidorasGeral.filter(x=> x.garId == this.Mensagem.garId);
        },
        nomeGarantidora(garId) {
            if (garId == null) return '';
            return this.GarantidorasGeral.find(x => x.garId == garId)?.garNomeEmpresa || '';
        },
        //edit
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.mpdId;
                axios.delete(`/Telas/MensagensPadrao/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                    }
                });
            }
            });
        },
        DeleteImagem(){
            this.Mensagem.mpdUrlImagem = "";
        },
        async Get() {
            this.EditView = false;
            try {
                const response = await axios.get(`/Telas/MensagensPadrao/GetDados`);
                this.Mensagens = response.data.mensagens || [];
                this.GarantidorasGeral = (response.data.garantidoras || []).filter(x => x.garVisivel);
                this.Garantidoras = this.GarantidorasGeral;
            } catch (error) {
                if (!error.__gpNotified) this.$mensagemErro(this.$obterMensagemErro(error));
            }
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style scoped>
.gp-replicate-dialog {
    overflow: hidden;
    border: 1px solid #e1d9cd;
    border-radius: 14px !important;
    background: #fffdf9;
    box-shadow: 0 18px 50px rgba(16, 42, 90, .18) !important;
}
.gp-replicate-dialog__header {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 16px 18px;
    border-bottom: 1px solid #e8e1d7;
    background: #fcf8f2;
    color: #102a5a;
    white-space: normal;
}
.gp-replicate-dialog__header > span:last-child {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 2px;
}
.gp-replicate-dialog__header strong {
    font-size: 14px;
    font-weight: 800;
    line-height: 1.3;
}
.gp-replicate-dialog__header small {
    color: #6f7b8f;
    font-size: 10.5px;
    font-weight: 500;
    line-height: 1.35;
}
.gp-replicate-dialog__icon {
    width: 36px;
    height: 36px;
    display: grid;
    flex: 0 0 36px;
    place-items: center;
    border-radius: 10px;
    background: #fff0df;
    color: #e77900;
}
.gp-replicate-dialog__body {
    padding: 20px 18px 18px !important;
}
.gp-replicate-dialog__body label {
    display: block;
    margin-bottom: 6px;
    color: #465168;
    font-size: 11px;
    font-weight: 750;
}
.gp-replicate-dialog__body .form-control {
    min-height: 36px;
    border-radius: 9px;
    font-size: 11.5px;
}
.gp-replicate-dialog__hint {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 8px;
    color: #748095;
    font-size: 10px;
}
.gp-replicate-dialog__actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 12px 18px 16px;
    border-top: 1px solid #eee7dd;
}
.gp-replicate-dialog__actions .btn {
    min-width: 104px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    margin: 0;
    padding: 7px 12px;
    border-radius: 9px;
    font-size: 11.5px;
    font-weight: 750;
}
@media (max-width: 575.98px) {
    .gp-replicate-dialog__actions {
        align-items: stretch;
        flex-direction: column-reverse;
    }
    .gp-replicate-dialog__actions .btn { width: 100%; }
}
</style>
